var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.10999 22.75C5.69999 22.75 5.35999 22.41 5.35999 22V2C5.35999 1.59 5.69999 1.25 6.10999 1.25C6.51999 1.25 6.85999 1.59 6.85999 2V22C6.85999 22.41 6.51999 22.75 6.10999 22.75Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.31 16.75H6.10999C5.69999 16.75 5.35999 16.41 5.35999 16C5.35999 15.59 5.69999 15.25 6.10999 15.25H17.31C18.4 15.25 18.91 14.96 19.01 14.71C19.11 14.46 18.96 13.9 18.18 13.13L16.98 11.93C16.49 11.5 16.19 10.85 16.16 10.13C16.13 9.37 16.43 8.62 16.98 8.07L18.18 6.87C18.92 6.13 19.15 5.53 19.04 5.27C18.93 5.01 18.36 4.75 17.31 4.75H6.10999C5.68999 4.75 5.35999 4.41 5.35999 4C5.35999 3.59 5.69999 3.25 6.10999 3.25H17.31C19.5 3.25 20.2 4.16 20.43 4.7C20.65 5.24 20.8 6.38 19.24 7.94L18.04 9.14C17.79 9.39 17.65 9.74 17.66 10.09C17.67 10.39 17.79 10.66 18 10.85L19.24 12.08C20.77 13.61 20.62 14.75 20.4 15.3C20.17 15.83 19.46 16.75 17.31 16.75Z",
    fill: "black",
    fillOpacity: 0.87
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.62feab815716d7655f22db92307eb070.svg";
export { ForwardRef as ReactComponent };